import { AppComponent }           from './../app.component';
import { Component, OnInit, Injector }      from '@angular/core';
import { TranslateService }       from '@ngx-translate/core';
import { UserService }            from '../_service/user.service';
import { InterfaceService }       from '../_service/interface.service';
import User                       from '../models/User';
import { BaseComponent }          from '../_components/BaseComponent';
import { HttpErrorResponse } 	  from "@angular/common/http";
import { CookieService } 	  from 'ngx-cookie-service';
import { BackendService } from '../_service/backend.service';
import { Constants } from '../models/Constants';

@Component({
  providers       : [ AppComponent ],
  selector        : 'app-login',
  templateUrl     : './login.component.html',
  styleUrls       : ['./login.component.css'],
})

export class LoginComponent extends BaseComponent implements OnInit {

  settings        : Object;

  login_selected  : string = null;
  
  constructor(
              injector : Injector,
              private _backendService   : BackendService,
              private _appCompontent    : AppComponent,
              ) 
  { 
    super(injector);
  }

  ngOnInit() 
  {
        this.login_selected = Constants.getSettingValue("login_selected");
  }

  softwareSettings() {
        this._backendService.getSoftwareSettings().subscribe(
            data => {
                var localstorage_key = this.project_labels + "_software_settings";
                localStorage.setItem(localstorage_key, JSON.stringify(data));
            },
            err => {
                let error_message = err.message !== undefined ? err.message : err.error;
            },
        );
    }

}
